/** @format */

import React from 'react';
import brand1 from '../images/Brands/brand-logo-l5-1 1.svg';
import brand2 from '../images/Brands/brand-logo-l5-2 1.svg';
import brand3 from '../images/Brands/brand-logo-l5-3 1.svg';
import brand4 from '../images/Brands/brand-logo-l5-4 1.svg';
import brand5 from '../images/Brands/brand-logo-l5-5 1.svg';
export const Brands = () => {
	return (
		<div className="brands-container">
			<h1 className="Featured">Featured on</h1>
			<div className="brand-images">
				<img src={brand1} alt="Geekwire" />
				<img src={brand2} alt="Slack" />
				<img src={brand3} alt="Envato" />
				<img src={brand4} alt="USA Today" />
				<img src={brand5} alt="Forbes" />
			</div>
		</div>
	);
};
